const ICON_MAP: Record<string, { color: string; bg: string; label: string }> = {
  pdf: { color: "text-red-600", bg: "bg-red-50", label: "PDF" },
  doc: { color: "text-blue-600", bg: "bg-blue-50", label: "DOC" },
  docx: { color: "text-blue-600", bg: "bg-blue-50", label: "DOC" },
  xls: { color: "text-green-600", bg: "bg-green-50", label: "XLS" },
  xlsx: { color: "text-green-600", bg: "bg-green-50", label: "XLS" },
  csv: { color: "text-green-600", bg: "bg-green-50", label: "CSV" },
  png: { color: "text-purple-600", bg: "bg-purple-50", label: "IMG" },
  jpg: { color: "text-purple-600", bg: "bg-purple-50", label: "IMG" },
  jpeg: { color: "text-purple-600", bg: "bg-purple-50", label: "IMG" },
  gif: { color: "text-purple-600", bg: "bg-purple-50", label: "IMG" },
  webp: { color: "text-purple-600", bg: "bg-purple-50", label: "IMG" },
  svg: { color: "text-purple-600", bg: "bg-purple-50", label: "IMG" },
  zip: { color: "text-yellow-600", bg: "bg-yellow-50", label: "ZIP" },
  txt: { color: "text-gray-600", bg: "bg-gray-50", label: "TXT" },
  ics: { color: "text-orange-600", bg: "bg-orange-50", label: "CAL" },
};

export function FileTypeIcon({ extension, className = "" }: { extension: string; className?: string }) {
  const info = ICON_MAP[extension.toLowerCase()] || { color: "text-gray-500", bg: "bg-gray-100", label: extension.toUpperCase().slice(0, 3) || "?" };
  return (
    <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-xs font-bold ${info.bg} ${info.color} ${className}`}>
      {info.label}
    </div>
  );
}
